module.exports = __webpack_public_path__ + "static/img/icon_doc.71d44572.svg";